import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressLightboxWrapper',
  setup(__props) {

const isLightboxOpen = ref<boolean>(false);
const index = ref<number>(0);
const onImageClick = (idx: number | undefined) => {
  isLightboxOpen.value = true;
  if (idx) {
    index.value = idx;
  }
};
const onLightboxHide = () => {
  isLightboxOpen.value = false;
  index.value = 0;
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    onImageClick: onImageClick,
    isLightboxOpen: isLightboxOpen.value,
    onLightboxHide: onLightboxHide,
    index: index.value
  })
}
}

})